import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const TabaPayDebitCardFundingLimitOptions = gql`
  query TabaPayDebitCardFundingLimitOptions {
    debitCardFundingLimitOptions {
      __typename
      ... on DebitCardFundingLimitOptionsSuccess {
        minAmount {
          amount
          currency
          formatted
        }
        maxAmount {
          amount
          currency
          formatted
        }
        options {
          id
          title
          __typename

          ... on DebitCardFundingOptionFixed {
            __typename
            id
            title
          }
          ... on DebitCardFundingOptionCustom {
            __typename
            id
            maxAmount {
              __typename
              amount
              currency
              formatted
              formattedWithPlusPrefix
            }
            minAmount {
              __typename
              amount
              currency
              formatted
              formattedWithPlusPrefix
            }
            title
          }
        }
        limitErrorMessage
        description
        dailyLimitInformation {
          title
          message1
          message2
        }

        monthlyLimitInformation {
          title
          message1
          message2
        }
        disclaimer
      }

      ... on DebitCardFundingLimitOptionsNotEligible {
        title
        message
        button {
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on SDBackNavigationAction {
              __typename
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }

      ... on DebitCardFundingLimitOptionsError {
        ...error
      }
    }
  }
  ${error}
  ${AnalyticsFragment}
`;

export default TabaPayDebitCardFundingLimitOptions;
